// Subtle art-deco corner ornaments for portrait frames.
// Renders four small gold brackets in the corners of the parent
// (which must be `position: relative`). Pure SVG, non-interactive.

const Corner = ({ rotate, size, color, opacity }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    style={{ transform: `rotate(${rotate}deg)` }}
    aria-hidden="true"
  >
    {/* Outer L */}
    <path
      d="M 0 32 L 0 0 L 32 0"
      stroke={color}
      strokeWidth="1.4"
      strokeLinecap="square"
      opacity={opacity}
    />
    {/* Inner L (offset stepped bracket - classic deco) */}
    <path
      d="M 5 22 L 5 5 L 22 5"
      stroke={color}
      strokeWidth="1"
      strokeLinecap="square"
      opacity={opacity * 0.6}
    />
    {/* Elbow diamond accent */}
    <rect
      x="9"
      y="9"
      width="4"
      height="4"
      transform="rotate(45 11 11)"
      fill={color}
      opacity={opacity * 0.9}
    />
  </svg>
);

export default function DecoCorners({
  size = 40,
  color = "#c9a04b",
  opacity = 0.85,
  inset = -8,
  testid,
}) {
  const base = {
    position: "absolute",
    pointerEvents: "none",
    zIndex: 2,
  };
  return (
    <div data-testid={testid} className="deco-corners" aria-hidden="true">
      <div style={{ ...base, top: inset, left: inset }}>
        <Corner rotate={0} size={size} color={color} opacity={opacity} />
      </div>
      <div style={{ ...base, top: inset, right: inset }}>
        <Corner rotate={90} size={size} color={color} opacity={opacity} />
      </div>
      <div style={{ ...base, bottom: inset, right: inset }}>
        <Corner rotate={180} size={size} color={color} opacity={opacity} />
      </div>
      <div style={{ ...base, bottom: inset, left: inset }}>
        <Corner rotate={270} size={size} color={color} opacity={opacity} />
      </div>
    </div>
  );
}
